/* eslint-disable jsx-a11y/img-redundant-alt */
import React, {lazy, Suspense, useState, useCallback} from 'react';
import Slider from "react-slick";
import mainPhoto from "../../assets/photos/mainPhoto1.webp"
import mainPhotoMobile from "../../assets/photos/mainPhotoMobile.webp"
import secondPhoto from "../../assets/photos/secondPhoto2.webp"
import secondPhotoMobile from "../../assets/photos/secondPhotoMobile.webp"
import aboutsidePhoto from "../../assets/photos/homepage/aboutside.webp"

import {useTranslation} from "react-i18next";
import useMediaQuery from '@mui/material/useMediaQuery';
import {Slide} from "react-reveal";
import Carousel from "react-multi-carousel";
import LoadingComponent from "../../components/Loading/LoadingComponent";
import ImageWithLoader from '../../components/ImageWithLoader';
import thirdPhoto from "../../assets/photos/thirdPhoto.webp"
import syol1 from "../../assets/photos/syol/syol1.jpg"
import oiltrt from "../../assets/photos/gabar/oiltrt1-cmp.webp"
import LiteYouTubeEmbed from 'react-lite-youtube-embed';
import 'react-lite-youtube-embed/dist/LiteYouTubeEmbed.css';
import TPAO from "../../assets/photos/references/tpao.webp"
import Mercedes from "../../assets/photos/references/mercedes.webp"
import Mobiliz from "../../assets/photos/references/mobiliz.webp"
import Transpet from "../../assets/photos/references/transpet.png"
import Global from "../../assets/photos/references/global_gaz.png"
import Arvento from "../../assets/photos/references/arvento.webp"
// Lazy load edilecek componentler
const ProjectShowcaseComponentLazy = lazy(() => import('../../components/ProjectShowcase/ProjectShowcaseComponent'));
const BackToTopComponentLazy = lazy(() => import('../../components/BackToTop/BackToTopComponent'));

// Basit carousel implementasyonu
function SimpleCarousel({ children }) {
  const [current, setCurrent] = useState(0);
  const length = React.Children.count(children);
  
  const next = useCallback(() => setCurrent(current === length - 1 ? 0 : current + 1), [current, length]);
  const prev = useCallback(() => setCurrent(current === 0 ? length - 1 : current - 1), [current, length]);
  
  return (
    <div className="carousel">
      <button onClick={prev}>Önceki</button>
      {React.Children.map(children, (child, index) => (
        <div key={`carousel-slide-${index}`} className={index === current ? 'slide active' : 'slide'}>
          {index === current && child}
        </div>
      ))}
      <button onClick={next}>Sonraki</button>
    </div>
  );
}

const HomePage = () => {
    const {t} = useTranslation()
    const isMobile = useMediaQuery('(max-width: 640px)'); // Assuming 640px is your mobile breakpoint

    const responsive = {
        superLargeDesktop: {
            breakpoint: { max: 4000, min: 1536 },
            items: 3,
            slidesToSlide: 3
        },
        desktop: {
            breakpoint: { max: 1536, min: 1024 },
            items: 3,
            slidesToSlide: 3
        },
        tablet: {
            breakpoint: { max: 1024, min: 640 },
            items: 2,
            slidesToSlide: 2
        },
        mobile: {
            breakpoint: { max: 640, min: 0 },
            items: 1,
            slidesToSlide: 1
        }
    };

    const references = [
        {
            name: "TPAO",
            imgUrl: TPAO,
        },
        {
            name: "Mercedes",
            imgUrl: Mercedes,
        },
        {
            name: "Mobiliz",
            imgUrl: Mobiliz,
        },
        {
            name: "Transpet",
            imgUrl: Transpet,
        },
        {
            name: "Global",
            imgUrl: Global,
        },
        {
            name: "Arvento",
            imgUrl: Arvento,
        }
    ];

 
    const settings = {
        dots: true,
        infinite: true,
        fade: true,
        autoplay: true,
        speed: 3000,
        arrows: false,
        autoplaySpeed: 4000,
    };
    



    return (
        <main>
            {/* Hero Section */}
            <section aria-label="Ana Sayfa" className="hero-section">
                        <div className={""}>
                            <Slider {...settings}>
                                <div className="relative">
                                    <img src={isMobile ? mainPhotoMobile : mainPhoto} alt="Image 1"
                                        className="w-full object-cover h-50 sm:h-48 md:h-96 lg:h-[40rem]"/>
                                    {/*bg-gradient-to-r from-yellow-600/70 to-transparent*/}
                                    {isMobile ? (
                                        <div className="absolute inset-0 flex justify-start p-5 pt-[7rem]">
                                            <p className="text-white font-extrabold italic text-md ">
                                                {t("mainIdea").split(' ').map((word, index) => (
                                                    (index > 0 && index % 3 === 0) ? (
                                                        <>
                                                            <br/>{`${word} `}
                                                        </>
                                                    ) : (
                                                        <>
                                                            {`${word} `}
                                                        </>
                                                    )
                                                ))}
                                            </p>
                                        </div>
                                    ) : (
                                        <div className="absolute inset-0 flex justify-start p-10 pt-20">
                                            <h2 className="text-white font-extrabold italic text-3xl md:text-3xl lg:text-6xl">
                                                {t("mainIdea").split(' ').map((word, index) => (
                                                    (index > 0 && index % 3 === 0) ? (
                                                        <>
                                                            <br/>{`${word} `}
                                                        </>
                                                    ) : (
                                                        `${word} `
                                                    )
                                                ))}
                                            </h2>
                                        </div>
                                    )}

                                </div>
                                <div>
                                    <img src={isMobile ? secondPhotoMobile : secondPhoto} alt="Image 2"
                                        className="w-full object-cover h-50 sm:h-48 md:h-96 lg:h-[40rem]"/>

                                    {isMobile ? (
                                        <div
                                            className="absolute left-1/2 transform -translate-x-1/2 flex justify-start text-center top-[2rem]">
                                            <h2 className="text-white font-extrabold italic text-xl">
                                                {t("mainIdea").split(' ').map((word, index) => (
                                                    (index > 0 && index % 2 === 0) ? (
                                                        <>
                                                            <br/> {`${word} `}
                                                        </>
                                                    ) : (
                                                        `${word} `
                                                    )
                                                ))}
                                            </h2>
                                        </div>
                                    ) : (
                                        <div
                                            className="absolute left-1/2 transform -translate-x-1/2  flex justify-center top-[2.5rem] text-center">
                                            <h2 className="text-white font-extrabold italic text-3xl md:text-3xl lg:text-6xl">
                                                {t("mainIdea").split(' ').map((word, index) => (
                                                    (index > 0 && index % 3 === 0) ? (
                                                        <>
                                                            <br/>{`${word} `}
                                                        </>
                                                    ) : (
                                                        `${word} `
                                                    )
                                                ))}
                                            </h2>
                                        </div>

                                    )}
                                </div>
                                <div>
                                    <img src={thirdPhoto} alt="Image 3"
                                        className="w-full object-cover h-50 sm:h-64 md:h-96 lg:h-[40rem]"/>
                                </div>
                            </Slider>
                        </div>


                        <div className={"container mx-auto mt-10 mb-20"}>
                            <Slide bottom duration={1000}>
                                <div className={"about my-20 mx-6"}>
                                    <div className={""}>
                                        <h1 className={"sm:text-4xl text-2xl text-center mb-0 font-semibold"}>
                                            {t("about").toLocaleUpperCase()}
                                        </h1>
                                    </div>

                                    <div className={"w-full block sm:flex items-center"}>
                                        <svg id="10015.io" viewBox="0 0 480 480" xmlns="http://www.w3.org/2000/svg"
                                            xmlnsXlink="http://www.w3.org/1999/xlink">
                                            <defs>
                                                <clipPath id="blob">

                                                    <path fill="#474bff"
                                                        d="M406.5,290Q396,340,359.5,380.5Q323,421,271,405Q219,389,180.5,371Q142,353,76.5,330Q11,307,19.5,242.5Q28,178,83.5,151Q139,124,175.5,83Q212,42,274.5,34.5Q337,27,385,71.5Q433,116,425,178Q417,240,406.5,290Z"/>
                                                </clipPath>
                                            </defs>
                                            <image x="0" y="0" width="100%" height="100%" clipPath="url(#blob)"
                                                xlinkHref={aboutsidePhoto}
                                                preserveAspectRatio="xMidYMid slice"
                                                alt="aboutsidePhoto"
                                                ></image>
                                        </svg>

                                        <div className={"font-semibold text-xl mx-4"}>
                                            <p>{t("aboutUsDesc")}</p>
                                            <br />
                                            <p>{t("aboutUsDesc2")}</p>
                                        </div>
                                    </div>
                                </div>
                            </Slide>

                            <div className={"transportation my-20"}>
                                <h3 className={"sm:text-4xl text-2xl text-center mb-10 font-semibold"}>
                                    {t("promotionalVideo")}
                                </h3>

                                <div className="relative w-full h-[500px] md:h-[600px] lg:h-[700px] overflow-hidden">
                                    <LiteYouTubeEmbed 
                                        id="JHmtXjwlDWw"
                                        title="Oil Trans Tanıtım Videosu"
                                        webp={true}
                                        noCookie={true}
                                        thumbnail={oiltrt}
                                    />
                                </div>
                            </div>

                            <div className={"projects mt-20"}>
                                <div className={"mb-5"}>
                                    <h2 className={"sm:text-4xl text-2xl text-center mb-0 font-semibold"}>
                                        {t("projects").toLocaleUpperCase()}
                                    </h2>
                                </div>

                                <div className={"projects-content-"}>
                                    <Carousel
                                        additionalTransfrom={0}
                                        swipeable={true}
                                        draggable={true}
                                        responsive={responsive}
                                        ssr={true}
                                        infinite={true}
                                        arrows={true}
                                        autoPlay={true}
                                        autoPlaySpeed={5000}
                                        keyBoardControl={true}
                                        customTransition="all 1s ease-in-out"
                                        transitionDuration={1000}
                                        containerClass="carousel-container"
                                        removeArrowOnDeviceType={["mobile"]}
                                        deviceType={isMobile ? "mobile" : "desktop"}
                                        itemClass="carousel-item-padding-40-px"
                                    >
                                        <Suspense fallback={<LoadingComponent loadingTimer={true} />}>
                                            <ProjectShowcaseComponentLazy
                                                title={t("projectDetails.gabar.title")}
                                                desc={t("projectDetails.gabar.desc")}
                                                link={"#"}
                                                img={oiltrt}
                                            />
                                        </Suspense>

                                        <Suspense fallback={<LoadingComponent loadingTimer={true} />}>
                                            <ProjectShowcaseComponentLazy
                                                title={t("projectDetails.iraq.title")}
                                                desc={t("projectDetails.iraq.desc")}
                                                link={"#"}
                                                img={"https://lh3.googleusercontent.com/p/AF1QipP_trDHsNTyWY6XxAemscB1W0KZSPOgsvgdjCs6=s1360-w1360-h1020"}
                                            />
                                        </Suspense>

                                        <Suspense fallback={<LoadingComponent loadingTimer={true} />}>
                                            <ProjectShowcaseComponentLazy
                                                title={t("projectDetails.syol.title")}
                                                desc={t("projectDetails.syol.desc")}
                                                link={"#"}
                                                img={syol1}
                                            />
                                        </Suspense>
                                    </Carousel>
                                </div>
                            </div>
                        </div>

                        {/* Tehlikeli Madde Taşımacılığı Bölümü */}
                        <div className="py-16 bg-gray-50 dark:bg-gray-900 my-20">
                            <div className="container mx-auto px-4">
                                <div className="max-w-4xl mx-auto text-center">
                                    <h2 className="text-3xl md:text-4xl font-bold mb-6">
                                        {t("dangerousGoods.title")}
                                    </h2>
                                    <div className="bg-white dark:bg-gray-800 rounded-xl shadow-lg p-8">
                                        <p className="text-lg text-gray-600 dark:text-gray-300 leading-relaxed">
                                            {t("dangerousGoods.desc")}
                                        </p>
                                        <div className="mt-8 grid grid-cols-2 md:grid-cols-2 gap-4">
                                            <div className="flex items-center justify-center p-4 bg-primary/10 rounded-lg">
                                                <span className="font-semibold">ADR</span>
                                            </div>
                                            <div className="flex items-center justify-center p-4 bg-primary/10 rounded-lg">
                                                <span className="font-semibold">SRC-5</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* References Section */}
                        <div className={"references mt-16"}>
                            <div className={"mb-10"}>
                                <h2 className={"sm:text-4xl text-2xl text-center mb-0 font-semibold"}>
                                    {t("references.title").toLocaleUpperCase()}
                                </h2>
                            </div>

                            <div className="references w-full grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-4">
                                {references.map((reference, index) => (
                                    <div key={`reference-${index}`} className={`flex flex-col items-center px-8 ${reference.name === "Transpet" ? "mt-32" : ""} ${reference.name === "Global" ? "mt-32" : ""}`}>
                                        <ImageWithLoader
                                            src={reference.imgUrl}
                                            alt={reference.name}
                                            loading="lazy"
                                            decoding="async"
                                            className={`${reference.name === "Global" || reference.name === "Transpet" ? "rounded-full" : ""}`}
                                            width={330}
                                            height={180}
                                        />
                                        <p className="font-semibold my-2 text-xl">{reference.name}</p>
                                    </div>
                                ))}
                            </div>
                        </div>
            </section>


            <Suspense fallback={<LoadingComponent loadingTimer={true} />}>
                <BackToTopComponentLazy/>
            </Suspense>
        </main>
    );
}

export default HomePage;